export default __webpack_public_path__ + "static/dde-90923f9185e22d8f8d9c8c33fb91f798.webp";